// 商品セクションスライダー初期化（改善版）
(function() {
  'use strict';
  
  let sparklingSwiper = null;
  let sherrySwiper = null;
  let initAttempts = 0;
  const MAX_ATTEMPTS = 50;

  // Swiperインスタンスを安全に破棄
  function destroySwiper(swiper) {
    if (swiper && typeof swiper.destroy === 'function') {
      try {
        swiper.destroy(true, true);
      } catch (e) {
        console.warn('Swiper destroy error:', e);
      }
    }
  }

  // スパークリングワインスライダーの初期化
  function initSparklingSwiper() {
    const container = document.querySelector('.p-top__section.-new-arrival .mvswiper');
    
    if (!container) {
      console.log('Sparkling container not found');
      return false;
    }

    // 既存のインスタンスを破棄
    destroySwiper(sparklingSwiper);
    sparklingSwiper = null;

    try {
      console.log('Initializing Sparkling Swiper...');
      
      sparklingSwiper = new Swiper('.p-top__section.-new-arrival .mvswiper', {
        // スマホ設定（デフォルト）
        slidesPerView: 2,
        slidesPerGroup: 2,
        spaceBetween: 8,
        
        // 基本設定
        loop: false,
        centeredSlides: false,
        watchOverflow: true,
        observer: true,
        observeParents: true,
        observeSlideChildren: true,
        
        // ナビゲーション
        navigation: {
          nextEl: '.p-top__section.-new-arrival .fes-slider-nav.next',
          prevEl: '.p-top__section.-new-arrival .fes-slider-nav.prev',
          disabledClass: 'swiper-button-disabled',
        },
        
        // ブレークポイント
        breakpoints: {
          // タブレット（769px以上）
          769: {
            slidesPerView: 3,
            slidesPerGroup: 3,
            spaceBetween: 12,
          },
          // PC（1025px以上）
          1025: {
            slidesPerView: 4,
            slidesPerGroup: 4,
            spaceBetween: 12,
          },
        },
        
        // イベントハンドラー
        on: {
          init: function() {
            console.log('Sparkling Swiper initialized');
            console.log('Current slidesPerView:', this.params.slidesPerView);
            console.log('Current spaceBetween:', this.params.spaceBetween);
          },
          resize: function() {
            console.log('Sparkling Swiper resized');
            console.log('Current slidesPerView:', this.params.slidesPerView);
          },
          slideChange: function() {
            console.log('Slide changed to:', this.activeIndex);
          },
        },
      });
      
      return true;
    } catch (error) {
      console.error('Failed to initialize Sparkling Swiper:', error);
      return false;
    }
  }

  // シェリースライダーの初期化
  function initSherrySwiper() {
    const container = document.querySelector('.p-top__section.-sherry .mvswiper');
    
    if (!container) {
      console.log('Sherry container not found');
      return false;
    }

    // 既存のインスタンスを破棄
    destroySwiper(sherrySwiper);
    sherrySwiper = null;

    try {
      console.log('Initializing Sherry Swiper...');
      
      sherrySwiper = new Swiper('.p-top__section.-sherry .mvswiper', {
        // スマホ設定
        slidesPerView: 2,
        slidesPerGroup: 2,
        spaceBetween: 12,
        
        // 基本設定
        loop: false,
        centeredSlides: false,
        watchOverflow: true,
        observer: true,
        observeParents: true,
        
        // ナビゲーション
        navigation: {
          nextEl: '.p-top__section.-sherry .swiper-button-next',
          prevEl: '.p-top__section.-sherry .swiper-button-prev',
        },
        
        // ブレークポイント
        breakpoints: {
          769: {
            slidesPerView: 3,
            slidesPerGroup: 3,
            spaceBetween: 16,
          },
          1025: {
            slidesPerView: 4,
            slidesPerGroup: 4,
            spaceBetween: 20,
          },
        },
        
        on: {
          init: function() {
            console.log('Sherry Swiper initialized');
          },
        },
      });
      
      return true;
    } catch (error) {
      console.error('Failed to initialize Sherry Swiper:', error);
      return false;
    }
  }

  // メイン初期化関数
  function initAllSwipers() {
    initAttempts++;
    
    // Swiperライブラリのチェック
    if (typeof Swiper === 'undefined') {
      if (initAttempts < MAX_ATTEMPTS) {
        console.log(`Swiper not ready, attempt ${initAttempts}/${MAX_ATTEMPTS}`);
        setTimeout(initAllSwipers, 100);
      } else {
        console.error('Swiper failed to load after maximum attempts');
      }
      return;
    }

    console.log('Swiper library loaded, initializing...');
    
    // スライダーを初期化
    const sparklingSuccess = initSparklingSwiper();
    const sherrySuccess = initSherrySwiper();
    
    if (sparklingSuccess || sherrySuccess) {
      console.log('Swiper initialization complete');
    } else {
      console.warn('No swipers were initialized');
    }
  }

  // スライダーの更新（リサイズ時など）
  function updateSwipers() {
    if (sparklingSwiper && sparklingSwiper.update) {
      sparklingSwiper.update();
      console.log('Sparkling Swiper updated');
    }
    if (sherrySwiper && sherrySwiper.update) {
      sherrySwiper.update();
      console.log('Sherry Swiper updated');
    }
  }

  // ページ読み込み完了後に初期化
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      console.log('DOM loaded, initializing swipers...');
      setTimeout(initAllSwipers, 100);
    });
  } else {
    console.log('DOM already loaded, initializing swipers...');
    setTimeout(initAllSwipers, 100);
  }

  // window.load でも念のため実行
  window.addEventListener('load', function() {
    console.log('Window loaded');
    // 既に初期化されていない場合のみ実行
    if (!sparklingSwiper && !sherrySwiper) {
      initAllSwipers();
    }
  });

  // リサイズ時の処理（デバウンス付き）
  let resizeTimer = null;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function() {
      console.log('Window resized, updating swipers...');
      updateSwipers();
    }, 250);
  });

  // デバッグ用：グローバルに公開
  window.debugSwipers = function() {
    console.log('=== Swiper Debug Info ===');
    console.log('Sparkling Swiper:', sparklingSwiper);
    console.log('Sherry Swiper:', sherrySwiper);
    
    if (sparklingSwiper) {
      console.log('Sparkling slides:', sparklingSwiper.slides.length);
      console.log('Sparkling slidesPerView:', sparklingSwiper.params.slidesPerView);
      console.log('Sparkling spaceBetween:', sparklingSwiper.params.spaceBetween);
    }
    
    if (sherrySwiper) {
      console.log('Sherry slides:', sherrySwiper.slides.length);
      console.log('Sherry slidesPerView:', sherrySwiper.params.slidesPerView);
    }
  };

  // 強制再初期化関数（デバッグ用）
  window.reinitSwipers = function() {
    console.log('Force reinitializing all swipers...');
    destroySwiper(sparklingSwiper);
    destroySwiper(sherrySwiper);
    sparklingSwiper = null;
    sherrySwiper = null;
    initAttempts = 0;
    initAllSwipers();
  };

})();